// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"60":"9bcced8d","145":"696c6e7d","239":"dfdb0d71","256":"54aa52f2","289":"da770373","386":"fd25766b","549":"c1818b8c","623":"8dea977f","772":"1e00fcd2","805":"96e7b473"}[chunkId] + ".chunk.js";
};